export default {
  message: 'BGP MD5 Password cannot include semicolon, spaces or pound.',
  fn: (value) => !/[#; ]/.test(value)
};
